import { normalizeProhorText } from "@/store/prohor/prohorMatch";
import { getPageHint } from "@/store/prohor/prohorPageHints";
import { formatProhorReply } from "@/store/prohor/prohorReplyFormat";

const WHAT_CAN_DO_PATTERNS = [
    /что\s+я\s+могу\s+(сделать|делать)\s+на\s+этой\s+страниц/,
    /что\s+можно\s+(сделать|делать)\s+на\s+этой\s+страниц/,
    /что\s+могу\s+на\s+этой\s+страниц/,
    /что\s+сделать\s+на\s+этой\s+страниц/,
    /что\s+делать\s+на\s+этой\s+страниц/,
    /что\s+есть\s+на\s+это\s+страниц/,
    /что\s+есть\s+на\s+этой\s+страниц/,
    /что\s+тут\s+можно/,
    /что\s+здесь\s+можно/,
    /помоги\s+(мне\s+)?(с|на)\s+этой\s+страниц/,
    /помощь\s+на\s+этой\s+страниц/,
    /помоги\s+на\s+этой\s+страниц/,
    /что\s+могу\s+(сделать|делать)\s+(здесь|тут)/,
    /что\s+можно\s+(сделать|делать)\s+(здесь|тут)/,
    /что\s+сделать\s+(здесь|тут)/,
    /что\s+делать\s+(здесь|тут)/,
    /что\s+могу\s+в\s+этом\s+раздел/,
    /что\s+можно\s+в\s+этом\s+раздел/,
];

const PURPOSE_PATTERNS = [
    /для\s+чего\s+мне\s+эта\s+страниц/,
    /для\s+чего\s+эта\s+страниц/,
    /зачем\s+мне\s+эта\s+страниц/,
    /зачем\s+эта\s+страниц/,
    /для\s+чего\s+этот\s+раздел/,
    /зачем\s+этот\s+раздел/,
    /для\s+чего\s+мне\s+нужен\s+этот\s+раздел/,
    /назначение\s+этой\s+страниц/,
];

export const detectPageContextMode = (question) => {
    const normalized = normalizeProhorText(question);
    if (!normalized) return null;

    if (WHAT_CAN_DO_PATTERNS.some((p) => p.test(normalized))) {
        return "whatCanDo";
    }
    if (PURPOSE_PATTERNS.some((p) => p.test(normalized))) {
        return "purpose";
    }
    return null;
};

export const buildPageContextReply = (question, path, role) => {
    const mode = detectPageContextMode(question);
    if (!mode) return null;

    if (!path) {
        return {
            text:
                "Откройте нужный раздел в меню и задайте вопрос снова — " +
                "тогда подскажу именно по этой странице.",
            actions: [{ label: "Помощь с ЛК", route: "/faq" }],
        };
    }

    const hint = getPageHint(path, role);
    const actions = Array.isArray(hint.actions) ? hint.actions : [];

    if (mode === "purpose") {
        return formatProhorReply({
            text: hint.purpose || hint.text,
            actions,
        });
    }

    const text = hint.whatCanDo || hint.text;

    return formatProhorReply({
        text,
        actions,
    });
};
